import { CounterPillModel } from '../BigNumbersArea.types';
import styles from '../styles.module.scss';

export const CounterPill = ({ id, label, value, total }: CounterPillModel) => (
  <span className={styles.pill} data-testid={`counter-pill-${id}`}>
    <strong className={styles['pill-value']}>{value}</strong>
    {total ? <strong className={styles['pill-total']}>{` / ${total}`}</strong> : null}
    <span className={styles['pill-label']}>{label}</span>
  </span>
);
